import React from 'react'
import { Dialog } from 'primereact/dialog';
import { Chart } from 'primereact/chart';
import isMobile from 'is-mobile';      
import ChartDataLabels from 'chartjs-plugin-datalabels';  
import { Avatar } from 'primereact/avatar';
import { buildTeamChartSeries } from './chart_data';
        
function TeamInfo(props) {
  let info = props.info
  let setInfo = props.setInfo
  let race_names = props.races
  let race_statuses = props.statuses || []
  let max = props.max
  let chartMax = Math.max(1, Math.trunc(max + (max/10)))
  let results = info?.['results'] || []
  let participation = info?.['participation'] || results.map(() => true)
  let raced = info?.['raced'] || results.map(() => true)
  let { pointsData, dnpData, rnhData } = buildTeamChartSeries(results, participation, race_statuses, raced)
  
  return (
    <>
    {
      info == null ? "" :
      <Dialog closeOnEscape dismissableMask className="m-0" header="Informazioni team" visible={info != null} position={"bottom"}  onHide={() => setInfo(null)} draggable={false} style={{maxWidth: "100%", width: isMobile() ? "100vw" : "60vw"}}>
        <div>
          <div className="grid">
            {
              !info['image'] ?
              <div className="col-12 col-md-4 md:col-4 flex align-content-center">
                <Avatar label={(info['name'] || '?').charAt(0).toUpperCase()} size="xlarge" shape="circle" style={{backgroundColor: "#e9ecef", color: "#495057", width: 200, height: 200, margin: "auto", fontSize: "4rem"}} />
              </div> :
              <div className="col-12 col-md-4 md:col-4 flex align-content-center">
                <img alt="" className="m-auto" src={info['image']} style={{width: 200, height: 200, borderRadius: "100%"}} />
              </div>
            }
            <div className="col-8 col-md-8 md:col-8">
              <h1 className="mb-1 mt-0">
                <span className="mr-2" style={{
                  color: "red",
                  borderLeft: "4px solid red",
                  paddingLeft: 5
                }}>{info['position']}</span>
                {info['name']}</h1>
              <h3 className="mb-2 mt-2">Piloti</h3>
              <div className="flex flex-wrap gap-2 mb-2">
                { info['drivers'].map((driver, index) =>
                  <div key={driver['id'] || index} style={{display: "inline-flex", alignItems: "center", gap: 8, backgroundColor: "transparent", border: "2px solid purple", borderRadius: 100, padding: "4px 12px 4px 4px"}}>
                    {
                      driver['image']
                        ? <img alt="" src={driver['image']} style={{width: 28, height: 28, borderRadius: "100%", objectFit: "cover"}} />
                        : <Avatar label={(driver['name'] || '?').charAt(0).toUpperCase()} size="normal" shape="circle" style={{backgroundColor: "#e9ecef", color: "#495057", width: 28, height: 28, fontSize: "0.9rem"}} />
                    }
                    <span>{driver['name']}</span>
                  </div>
                ) }
              </div>
            </div>
          </div>
          <h3>Risultati</h3>
          <div style={{height: 320}}>
          <Chart
            type="line"
            plugins={[ChartDataLabels]}
            data={{
              labels: race_names,
              datasets: [
                {
                  label: "Punti",
                  data: pointsData,
                  tension: 0.4,
                  borderWidth: 1.7,
                  spanGaps: false,
                  pointBorderColor: "white",
                  pointBackgroundColor: "purple"
                },
                {
                  label: "DNP",
                  data: dnpData,
                  isDnpDataset: true,
                  showLine: false,
                  pointRadius: 5,
                  pointBorderColor: "white",
                  pointBackgroundColor: "#6c757d"
                },
                {
                  label: "RNH",
                  data: rnhData,
                  isRnhDataset: true,
                  showLine: false,
                  pointRadius: 5,
                  pointBorderColor: "white",
                  pointBackgroundColor: "#343a40"
                }
              ]
            }}
            options={{
              maintainAspectRatio: false,
              aspectRatio: 1,
              plugins: {
                legend: { display: false },
                datalabels: {
                  // anchor: 'start',
                  align: 'end',
                  color: 'white',
                  backgroundColor: (context) => context.dataset.isRnhDataset ? "#343a40" : (context.dataset.isDnpDataset ? "#6c757d" : "purple"),
                  borderRadius: 5,
                  clamp: true,
                  formatter: (value, context) => context.dataset.isRnhDataset ? "RNH" : (context.dataset.isDnpDataset ? "DNP" : value),
                  font: {
                    size: 13,
                  },
                },
                tooltip: {
                  callbacks: {
                    label: (context) => context.dataset.isRnhDataset ? "RNH" : (context.dataset.isDnpDataset ? "DNP" : `Punti: ${context.raw}`),
                  },
                },
              },
              scales: {
                y: {
                  min: 0,
                  max: chartMax
                }
              }
            }}/>
          </div>
        </div>
      </Dialog>
      }
    </>
  )
}

export default TeamInfo
